/**
 * class for the entries in the components array of a template
 */
import { ChangeSourceType } from './change-source.type';

export interface FieldChanges {
  fieldName?: string;
  newValue?: any;
  oldValue?: any;
  source?: ChangeSourceType;
}
